<ds-accordion style="margin-top: 1%">
  <ds-accordion-item>
    Deactivated Authorized Drivers
    <div content>
      <div style="height: 400px; display: flex">
        <ds-box style="flex: 1">
          <ds-box-header
            >Driver License Information (as it appears in state issued driver
            license)</ds-box-header
          >
          <ds-box-content>Employee Form</ds-box-content>
          <ds-box-footer class="d-flex justify-content-end">
            <button
              ds-button
              aria-label="Reactivate Authorized Driver"
              (click)="handleReactivateAuthorizedDriver()"
            >
              REACTIVATE AUTHORIZED DRIVER
            </button></ds-box-footer
          >
        </ds-box>
      </div>
    </div>
  </ds-accordion-item>
</ds-accordion>
